import React from 'react';
import ClassicEditor from "../../../../components/classicEditor";
import SettingEditorFieldCredential from "./settingEditorFieldCredential";
import SettingEditorFieldPaymentMethod from "./settingEditorFieldPaymentMethod";


export default function SettingEditorField({label, originalValue, value, setValue, settingType}) {
     
    if (settingType === 'boolean') {
        return (
            <div>
                <label>
                    <input
                        type="checkbox" className="me-2"
                        defaultChecked={originalValue} checked={value}
                        onChange={(e) => setValue(e.target.checked)}/>
                    {label}
                </label>
            </div>
        );
    }
    if (settingType === 'number') {
        return (
            <input type="number" defaultValue={originalValue} value={value} onChange={(e) => setValue(e.target.value)}/>
        );
    }
    if (settingType === 'json') {
        return (
            <textarea
                onChange={(e) => setValue(e.target.value)}
                defaultValue={JSON.stringify(originalValue, null, 2)} rows="10"/>
        );
    }
    if (settingType === 'credential') {
        return (
            <SettingEditorFieldCredential
                value={value}
                originalValue={originalValue}
                setValue={setValue}
                />
        );
    }
    if (settingType === 'html') {
        return (
            <ClassicEditor
                initialValue={originalValue}
                value={value}
                onEditorChange={newContent => {
                    setValue(newContent)
                }}
            />
        );
    }

    if (settingType === 'payment_method') {
        return (
            <SettingEditorFieldPaymentMethod
                value={value}
                originalValue={originalValue}
                setValue={setValue}
                />
        )
    }

    return (
        <input
            type="text"
            defaultValue={originalValue}
            value={value}
            onChange={(e) => setValue(e.target.value)}
        />
    );
}